import Page from '../../layout/Page';
import { useParams } from 'react-router-dom';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import PlateReads from '../plateReads/CustomerPlateReads';
import PlateReadAwards from '../plateReads/CustomerPlateReadAwards';
import PlateReadMessages from '../plateReads/CustomerPlateReadMessages';
import RequireFeature, { Features } from '../../RequireFeature';

const Visitor = ({ ...props }) => {

    const { plate } = useParams();

            return (
            <RequireFeature requiredFeatures={Features.PlateReads}>
                <Page
                    tabTitle={plate}
                    title={'Visitor ' + plate}
                    icon=''
                    HSpage='visitor_page'
                    tabs
                >
                    <PageBreak tab='Plate Reads'>
                        <PlateReadAwards plate={plate} />
                        <PlateReadMessages plate={plate} />
                        <PlateReads plate={plate} />
                    </PageBreak> 
                </Page>
            </RequireFeature>
            )
}

export default Visitor;